import type { SubjectType } from '../subject/res';
import type ResType from '../type';
import type { UserType } from '../user/res';
import type {
  AcademicStatusEnum,
  GenderEnum,
  HighschoolCategoryEnum,
  TutoringMethodEnum,
} from './req';

export enum ApplicationStatusEnum {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum UniversityExistenceEnum {
  UNIVERSITY = 'UNIVERSITY_ONLY', // University만 존재
  ALL = 'ALL', // University, Major 모두 존재
  NONE = 'NONE', // University, Major 둘다 존재 x
}

export enum TutorApplicationTypeEnum {
  NEW = 'NEW', // 신규 신청
  UNIVERSITY_MODIFY = 'UNIVERSITY_MODIFY', // 대학 정보 수정
}

export type TutorSubjectType = {
  subjectId: string;
  subjectName: string;
};

export type UserEduUniversityType = {
  id: string;
  universityId: string;
  universityName: string;
  universityImage: string;
  departmentName: string;
  studentNumber: string;
  academicStatus: AcademicStatusEnum;
  proofFileUris: string[];
};

export type UserPassUniversityType = {
  id: string;
  universityId: string;
  universityName: string;
  universityImage: string;
  departmentName: string;
  proofFileUris: string[];
  isProofed: boolean;
};

export type TutorSummaryType = {
  tutorId: string;
  tutorTitle: string;
  eduUniversities: UserEduUniversityType[];
  subjectNames: string[];
  profileImageUrl: string;
};

export type TutorDetailType = {
  tutorId: string;
  nickname: string;
  gender: GenderEnum;
  age: number;
  contact: string;
  profileImageUrl: string;
  highschoolCategory: HighschoolCategoryEnum;
  title: string;
  description: string;
  tuition: number;
  tuitionDescription: string;
  method: TutoringMethodEnum;
  subjectNames: string[];
  eduUniversities: UserEduUniversityType[];
  passUniversities: UserPassUniversityType[];
};

export type TutorAdminDetailType = TutorDetailType & {
  name: string;
  nickname: string;
  email: string;
  createdAt: string;
  updatedAt: string;
  subjectIds: string[];
};

export type TutorApplicationType = {
  id: string;
  profileImageUri: string;
  title: string;
  method: TutoringMethodEnum;
  tuition: number;
  tuitionDescription: string;
  highschoolCategory: HighschoolCategoryEnum;
  contact: string;
  description: string;
  status: ApplicationStatusEnum;
  rejectReason: string | null;
  eduUniversities: UserEduUniversityType[];
  passUniversities: UserPassUniversityType[];
  subjects: TutorSubjectType[];
  user: UserType;
  age: number;
  gender: GenderEnum;
  applicationType: TutorApplicationTypeEnum;
  createdAt: string;
  updatedAt: string;
  existencies: {
    main: UniversityExistenceEnum | null;
    passList: UniversityExistenceEnum[] | null;
  };
};

export type PostTutorUniversityModifyResType = ResType<{}>;

export type GetTutorSummaryResType = ResType<{ totalCount: number; summaries: TutorSummaryType[] }>;

export type GetTutorDetailResType = ResType<TutorDetailType>;

export type GetTutorDetailsResType = ResType<{
  totalCount: number;
  details: TutorAdminDetailType[];
}>;

export type PatchTutorDetailResType = ResType<{}>;

export type PostTutorApplicationResType = ResType<{}>;

export type GetAllUsersApplicationResType = ResType<{
  totalCount: number;
  applications: TutorApplicationType[];
}>;

export type PatchApplicationApprovalResType = ResType<{}>;

export type PostAdminTutorResType = ResType<{}>;

export type PutAdminTutorResType = ResType<{}>;

export type DeleteAdminTutorResType = ResType<{}>;

export type GetUserTutorExistResType = ResType<boolean>;

export type UserTutorDetailType = {
  tutorId: string;
  gender: GenderEnum;
  age: number;
  contact: string;
  profileImageUrl: string;
  highschoolCategory: HighschoolCategoryEnum;
  title: string;
  description: string;
  tuition: number;
  tuitionDescription: string;
  method: TutoringMethodEnum;
  subjects: SubjectType[];
  eduUniversities: UserEduUniversityType[];
  passUniversities: UserPassUniversityType[];
};
export type GetUserTutorDetailResType = ResType<UserTutorDetailType>;

export type GetUserTutorApplicationStatusResType = ResType<{
  status: ApplicationStatusEnum | null;
  rejectReason: string | null;
  applicationType: TutorApplicationTypeEnum | null;
}>;

export type PutAdminTutorEduResType = ResType<{}>;
